module.exports = __webpack_public_path__ + "img/switch-circle-active.12c3f0cd.svg";